/* eslint-disable @typescript-eslint/no-var-requires */
export const logger = require('pino')();